<script lang="ts">
    import { _ } from "svelte-i18n"
    import {onMount} from "svelte";

    import TemplateStandard from "../../shared/TemplateStandard.svelte";
    import {mainMenu} from "../../../stores/store";
    import SettingsGeneral from "./SettingsGeneral.svelte";
    import MenuContextJobs from "../MenuDropdown/MenuContextJobs.svelte";
    import TemplateHeaderTrio from "../../shared/TemplateHeaderTrio.svelte";
    import GeocodingStatusWithProgressBar from "../Import/GeocodingStatusWithProgressBar.svelte";
    import TemplateHeaderUno from "../../shared/TemplateHeaderUno.svelte";

    onMount( () => {
        $mainMenu.currentPage = 'PageSettings';
    })

</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderUno>
            <div slot="main-header">
                {$_('Settings')}
            </div>
        </TemplateHeaderUno>
    </div>
    <div slot="content">
        <SettingsGeneral />
    </div>
</TemplateStandard>
